import { Component, OnInit, HostListener, ViewChild, AfterViewInit, OnDestroy, ElementRef, ChangeDetectorRef } from '@angular/core';


import { AppState } from '../app.service';
// import { Title } from './title';
// import { XLargeDirective } from './x-large';

import { TweenMax, TimelineMax } from "gsap";
//import * as $ from 'jquery/dist/jquery.min.js';
import { ActivatedRoute }    from '@angular/router';
import { Subscription } from 'rxjs/Subscription';

var $ = require('jquery');
require('jquery-ui-bundle');

//import * as $ from 'jquery/dist/jquery.min.js';

import { FormsModule, ReactiveFormsModule, FormGroup, FormControl, FormBuilder, Validators } from '@angular/forms';
import { BrowserModule, Title }  from '@angular/platform-browser';

declare var elements;
declare var stripe;


@Component({
  /**
   * The selector is what angular internally uses
   * for `document.querySelectorAll(selector)` in our index.html
   * where, in this case, selector is the string 'home'.
   */
  selector: 'book',  // <home></home>
  /**
   * We need to tell Angular's Dependency Injection which providers are in our app.
   */
  providers: [
    Title
  ],
  /**
   * Our list of styles in our component. We may add more to compose many styles together.
   */
  styles: [ require('./book.component.css') ],
  /**
   * Every Angular template is first compiled by the browser before Angular runs it's compiler.
   */
  template: require('./book.component.html')
})
export class BookComponent implements OnInit, AfterViewInit, OnDestroy {
  /**
   * Set our default values
   */
  public localState = { value: '' };
  public myForm: FormGroup; // our model driven form
  public submitted: boolean; // keep track on whether form is submitted
  experience: number;
  fees: any;

  @ViewChild('cardInfo') cardInfo: ElementRef;
  card: any;
  cardHandler = this.onChange.bind(this);
  error: string;
  pay_now: number = 0;
  pay_later: any;
  tos:boolean = false;
  disable_pay_button: boolean = false;
  show_thank_you: boolean = false;
  is_loading:boolean = false;
  
  pay_now_btn: any = "Please Select Experience";
  air_experiences: any;
  sub: any;
  part:any;
  bought_voucher: any = {
    voucher_code: ""
  };

  /**
   * TypeScript public modifiers
   */
  constructor(
    public appState: AppState,
    public title: Title,
    private _fb : FormBuilder,
    private cd: ChangeDetectorRef,
    private activatedRoute: ActivatedRoute
  ) {}


  ngAfterViewInit() {
    this.card = elements.create('card');
    this.card.mount(this.cardInfo.nativeElement);
    this.card.addEventListener('change', this.cardHandler);
  }

  ngOnDestroy() {
    this.card.removeEventListener('change', this.cardHandler);
    this.card.destroy();
  }

  onChange({ error }) {
    if (error) {
      this.error = error.message;
    } else {
      this.error = null;
      this.check_pay();
    }
    this.cd.detectChanges();
  }

  check_pay(){

    //validating the form before we go further
    if(this.experience > 0){

      this.update_experience();
      
      // this.pay_now_btn = "Pay £"+this.pay_now;
      // this.disable_pay_button = false;
    }

    


  }

  
  public ngOnInit() {
    // console.log('hello `book` component');
    this.title.setTitle("The Tiger Club | Book An Experience");
    this.fees = this.appState.getFees();

  
    
    this.air_experiences = [
        {
          id: 1,
          title: "Tiger Moth - 20 minutes",
          short: "tiger20",
          price: this.fees.tiger.experience_20
        },
        {
          id: 2,
          title: "Tiger Moth - 30 minutes",
          short: "tiger30",
          price: this.fees.tiger.experience_30
        },
        {
          id: 3,
          title: "Tiger Moth - 40 minutes",
          short: "tiger40",
          price: this.fees.tiger.experience_40
        },
        {
          id: 4,
          title: "Aerobatics - 20 minutes",
          short: "aero20",
          price: this.fees.cap.experience_20
        }
    ];


    this.appState.get_super_secret_token({cost: this.air_experiences[0].price, experience: this.air_experiences[0].title}).subscribe((data: any) => {
             var data = JSON.parse(data._body);
             //console.log("super_secret_token ::: ", data);
            this.super_secret_token = data.intent.client_secret;
          });

    this.sub = this.activatedRoute
      .params
      .subscribe(params => {
        this.part = params['part'];
        console.log("part is ", this.part);
        if(this.part && this.part !== ""){
          this.auto_set_select(this.part);
        }
      });


    if( $('[type="date"]').prop('type') !== 'date' ) {
       $('[type="date"]').datepicker();
    }

    this.myForm = this._fb.group({
            experience: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            first_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            last_name: ['', [<any>Validators.required, <any>Validators.minLength(2)]],
            email: ['', [<any>Validators.required, <any>Validators.minLength(5)]],
            phone_number: ['', [<any>Validators.required, <any>Validators.minLength(7)]],
            tnc: ['', [<any>Validators.required, <any>Validators.required]],
            preferred_date: ['', []],
            notes: ['', []]
        });

     }

     super_secret_token:any = "";

     update_experience(){
      // console.log("UPDATE CALLED");

     


       var ids = this.experience;
      // console.log("id: ",ids);
       var found = this.air_experiences.find(function(el) {
         return el.id == ids;
       });
      // console.log("id: ",found);
      this.selected_experience = found;
      this.experience = found.id


       this.appState.get_super_secret_token({cost: this.selected_experience.price, experience: found.title, receipt: this.myForm.controls.email.value}).subscribe((data: any) => {
             var data = JSON.parse(data._body);
             console.log("super_secret_token ::: ", data);
            this.super_secret_token = data.intent.client_secret;
          })



      this.pay_now_btn = "Pay £"+this.selected_experience.price;
  }


  discount = {
    value: 0
  };

   update_notes(){
      // console.log("UPDATE CALLED");

       if(this.myForm.controls.notes.value == "123discount"){

         console.log("discount applicable!!");

         //10% discount example...
         // this.selected_experience.discount = this.selected_experience.price * 0.1;
         // this.discount.value = this.selected_experience.discount;
         // this.pay_now_btn = "Pay £"+(this.selected_experience.price - this.selected_experience.discount );


       }
  }


     selected_experience:any;

     auto_set_select(exp){
       // console.log("exp", exp);
       var found = this.air_experiences.find(function(el) {
         return el.short === exp;
       });
       this.selected_experience = found;
       this.experience = found.id
       this.pay_now_btn = "Pay £"+this.selected_experience.price;
       // console.log(this.experience);
     }

  // updated_select(val){
  //   // console.log("UPDATED", val);
  //   this.experience = val;
  // }
  
  async save(data, valid){

    if(data.email !== ""){

      
    } else {
      alert("Please enter your email address");
      return false;
    }

    if(valid){

      this.is_loading = true;
      //then take the charge...
      this.disable_pay_button = true;



      var cardholderName = document.getElementById('cardholder-name');
      var cardButton = document.getElementById('card-button');
      var clientSecret = cardButton.dataset.secret;

      var _this = this;

        stripe.handleCardPayment(
          clientSecret, this.card, {
            payment_method_data: {
              billing_details: {name: data.first_name+" "+data.last_name}
            },
            receipt_email: data.email
          }
        ).then(function(result) {
          if (result.error) {
            // Display error.message in your UI.
            // console.log('Something is wrong:', result.error);
            alert(result.error.message);
            _this.disable_pay_button = false;
            _this.is_loading = false;

            return false;

          } else {
            // The payment has succeeded. Display a success message.
            // console.log("RESULTS", result);

              data.experience = _this.selected_experience.title;
              data.token_id = result.paymentIntent.id;
              data.cost = result.paymentIntent.amount / 100;

              // console.log("BEFORE SEND NOW ==> ", data);


              //generate_the_voucher
              _this.appState.buy_voucher(data).subscribe((content: any) => {

                // console.log("BUY RESPONSE ", content);
                var response = JSON.parse(content._body);
                // console.log("BUY RESPONSE2 ", response);
                _this.bought_voucher = response.voucher;

                if(response.success){



              data.name = data.first_name+" "+data.last_name;
              data.title = "Air Experience Voucher";
              data.voucher_code = _this.bought_voucher.voucher_code;


              // console.log("EMAILS NOW ==> ", data);
              // console.log("SPECIFICALLY ==> EXPERIENCE: ", data.experience);



              //SEND THE EMAIL TO USER --> THANK YOU FOR CONTACT
              var user_body = {
                  From: "info@tigerclub.co.uk",
                  To: data.email,
                  TemplateId: 11608568,
                  TemplateModel: data
                };
               // console.log("USER SENT HERE ", user_body);

              _this.appState.send_email(user_body).subscribe((data: any) => {
                  // console.log("USER SENT HERE ", data);
                });


              //SEND THE EMAIL TO STAFF
              var staff_body = {
                  From: "info@tigerclub.co.uk",
                  To: "info@tigerclub.co.uk",
                  TemplateId: 5523702,
                  TemplateModel: data
                };

                // console.log("STAFF SENT HERE ", staff_body);
                _this.appState.send_email(staff_body).subscribe((data: any) => {
                  // console.log("STAFF SENT HERE ", data);
                })

                _this.show_thank_you = true;

                $("#the_form").fadeOut();
                $("#thank_you").fadeIn();
                _this.disable_pay_button = false;

              } else {
                // this.bought_voucher.voucher_code = "";
                data.message = response.message;
                data.name = data.first_name+" "+data.last_name;
                data.title = "Air Experience Voucher ERROR";

                var staff_body = {
                  From: "info@tigerclub.co.uk",
                  To: "social@tigerclub.co.uk",
                  TemplateId: 5523702,
                  TemplateModel: data
                };

                // console.log("STAFF SENT HERE ", staff_body);
                _this.appState.send_email(staff_body).subscribe((data: any) => {
                  // console.log("STAFF SENT HERE ", data);
                })
                //an error occurred..... 
                alert("An error has ocurred, "+response.message);
                _this.disable_pay_button = false;
                _this.is_loading = false;
                return false;

              }

              },
              (err) => {
                // this.bought_voucher.voucher_code = "";
                //console.log(err);


                data.message = err.message;
                data.name = data.first_name+" "+data.last_name;
                data.title = "Air Experience Voucher ERROR";

                var staff_body = {
                  From: "info@tigerclub.co.uk",
                  To: "social@tigerclub.co.uk",
                  TemplateId: 5523702,
                  TemplateModel: data
                };

                // console.log("STAFF SENT HERE ", staff_body);
                _this.appState.send_email(staff_body).subscribe((data: any) => {
                  // console.log("STAFF SENT HERE ", data);
                })

                alert("An error has ocurred, "+err.message);
                _this.disable_pay_button = false;
                _this.is_loading = false;

                return false;
              });







          }
        });







      // const { token, error } = await stripe.createToken(this.card, {
      //   email: data.email
      // });

      // if (error) {

      //   console.log('Something is wrong:', error);
      //   alert(error.message);
      //   this.disable_pay_button = false;
      //   this.is_loading = false;
      //   return false;

      // } else {
      //   // console.log('Success!', token);
      //   // ...send the token to the your backend to process the charge
      //   var tobesent = {
      //     stripeToken: token
      //   };

      //   data.stripeToken = token;
      //   data.cost = this.selected_experience.price;
      //   data.experience = this.selected_experience.title;
      //   //all fields are filled in
      //   // $("#the_form").fadeOut();
      //   // $("#thank_you").fadeIn();
        
        
     


      //   //generate_the_voucher
      //   this.appState.buy_voucher(data).subscribe((content: any) => {

      //     // console.log("BUY RESPONSE ", content);
      //     var response = JSON.parse(content._body);
      //     // console.log("BUY RESPONSE2 ", response);
      //     this.bought_voucher = response.voucher;

      //     if(response.success){



      //   data.name = data.first_name+" "+data.last_name;
      //   data.title = "Air Experience Voucher";
      //   data.voucher_code = this.bought_voucher.voucher_code;

      //   //SEND THE EMAIL TO USER --> THANK YOU FOR CONTACT
      //   var user_body = {
      //       From: "info@tigerclub.co.uk",
      //       To: data.email,
      //       TemplateId: 11608568,
      //       TemplateModel: data
      //     };
      //    // console.log("USER SENT HERE ", user_body);

      //   this.appState.send_email(user_body).subscribe((data: any) => {
      //       // console.log("USER SENT HERE ", data);
      //     });


      //   //SEND THE EMAIL TO STAFF
      //   var staff_body = {
      //       From: "info@tigerclub.co.uk",
      //       To: "info@tigerclub.co.uk",
      //       TemplateId: 5523702,
      //       TemplateModel: data
      //     };

      //     // console.log("STAFF SENT HERE ", staff_body);
      //     this.appState.send_email(staff_body).subscribe((data: any) => {
      //       // console.log("STAFF SENT HERE ", data);
      //     })

      //     $("#the_form").fadeOut();
      //     $("#thank_you").fadeIn();

      //   } else {
      //     // this.bought_voucher.voucher_code = "";
      //     data.message = response.message;
      //     data.name = data.first_name+" "+data.last_name;
      //     data.title = "Air Experience Voucher ERROR";

      //     var staff_body = {
      //       From: "info@tigerclub.co.uk",
      //       To: "social@tigerclub.co.uk",
      //       TemplateId: 5523702,
      //       TemplateModel: data
      //     };

      //     // console.log("STAFF SENT HERE ", staff_body);
      //     this.appState.send_email(staff_body).subscribe((data: any) => {
      //       // console.log("STAFF SENT HERE ", data);
      //     })
      //     //an error occurred..... 
      //     alert("An error has ocurred, "+response.message);
      //     this.disable_pay_button = false;
      //     this.is_loading = false;
      //     return false;

      //   }

      //   },
      //   (err) => {
      //     // this.bought_voucher.voucher_code = "";
      //     console.log(err);


      //     data.message = err.message;
      //     data.name = data.first_name+" "+data.last_name;
      //     data.title = "Air Experience Voucher ERROR";

      //     var staff_body = {
      //       From: "info@tigerclub.co.uk",
      //       To: "social@tigerclub.co.uk",
      //       TemplateId: 5523702,
      //       TemplateModel: data
      //     };

      //     // console.log("STAFF SENT HERE ", staff_body);
      //     this.appState.send_email(staff_body).subscribe((data: any) => {
      //       // console.log("STAFF SENT HERE ", data);
      //     })

      //     alert("An error has ocurred, "+err.message);
      //     this.disable_pay_button = false;
      //     this.is_loading = false;

         


      //     return false;
      //   });





      // }




      









    } else {
      // console.log("FAILED?");
      alert("Please complete all fields in the form.");
    }
  }

  public scrollTo(id){
     $('html, body').animate({
        scrollTop: $("#"+id).offset().top - 80
    }, 1000);
  }

  public submitState(value: string) {
    // console.log('submitState', value);
    this.appState.set('value', value);
    this.localState.value = '';
  }
}



// WEBPACK FOOTER //
// node_modules/ngc-webpack??ref--0-2!./node_modules/angular2-template-loader!./src/app/book/book.component.ts